<template>
    <div class="history-point m-auto">
        <div class="month-picker-box m-auto pt-5 pb-0">
            <MonthPickerDropdown
                    v-model:inputValue="monthSelect"
                    :inputLbl="lbl.history.monthPicker"
                    @update:inputValue="onMonthSelect()"
            ></MonthPickerDropdown>
        </div>

        <div class="border px-3" v-show="historyList.length > 0 && isLoaded">
            <HistoryPointItem
                    v-for="(v,k) in historyList"
                    :key="v.rowKey"
                    :pointItem="v"
                    :isLastItem="k == historyList.length-1"
            ></HistoryPointItem>
        </div>
        <div class="text-center py-20" v-show="historyList.length == 0 && isLoaded">
            Not found
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
//component
import MonthPickerDropdown from '@/components/Input/label/MonthPickerDropdown.vue';
import HistoryPointItem from './HistoryPointItem.vue';
//service
import BzbsPoint from '@/core/Point/service/BzbsPoint.js';
import { HistoryPointConfigBuilder } from '@/core/Point/config/PointConfigModel.js'

export default {
    name: 'HistoryPoint',
    mixins: [LocaleMixin],
    components: {
        MonthPickerDropdown,
        HistoryPointItem,
    },
    data: function() {
        return {
            monthSelect: new Date(),
            historyList: [],
            isLoaded: false,
        };
    },
    methods: {
        onMonthSelect: function() {
            Util.log('select month', this.monthSelect);

            let configParams = new HistoryPointConfigBuilder()
                    .setMonth(this.monthSelect)
                    .setType('earn')
                    .create()
                    .getParams();
            this.getHistoryPoint(configParams);
        },
        getHistoryPoint: function(configParams) {
            BzbsPoint.apiGetPointHistory(configParams).subscribe({
                next: (data) => {
                    console.log(data);
                    this.historyList = data;
                    this.isLoaded = true;
                },
                error: (err) => {
                    this.errorApi(err);
                },
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    .history-point {
        max-width: 500px;
    }
    .month-picker-box {
        max-width: 250px;
    }
</style>
